#import "./confluence-reaction-fragment.graphql"

query CommentReactionList($comments: [ReactionsId]!) {
  reactionsSummaryList(ids: $comments) {
    ...ReactionsSummaryResponseFragment
  }
}
